<template>
      <div class="tile is-child box">
        <div class="tags has-addons">
          <span class="tag  is-medium">Info</span>
          <span class="tag is-info is-medium">Music</span>
        </div>
        <div class="field">
          <h1 class="title is-4">{{ musicobj.currentTrackInformation.title }}</h1>
          <p>{{ musicobj.currentTrackInformation.author }}</p>
        </div>
        <div class="field has-addons">
          <progress class="progress" v-bind:value="musicobj.currentTrackInformation.position" v-bind:max="musicobj.currentTrackInformation.length">15%</progress>
        </div>
        <div>
          <p>{{ millisToMinutesAndSeconds(musicobj.currentTrackInformation.position) }} / {{ millisToMinutesAndSeconds(musicobj.currentTrackInformation.length) }}</p>
        </div>
        <div class="field"> 
        </div>
        <div class="field">
          <div class="buttons">
            <button class="button is-success is-rounded" v-on:click="play()">Play</button>
            <button class="button is-warning is-rounded" v-on:click="pause()">Pause</button>
            <button class="button is-primary is-rounded" v-on:click="skip()">Skip</button>
            <button class="button is-danger is-rounded" v-on:click="stop()">Stop</button>
          </div>
        </div>
        <div class="field has-addons">
          <input class="input" v-model="queueString" type="text" placeholder="url or youtube search string">
          <div class="control">
            <button class="button is-primary" @click="addToQueue()">
              Add to Queue
            </button>
          </div>
        </div>  
        <div class="field">
          <table class="table is-hoverable is-fullwidth">
            <tbody>
              <tr 
              v-for="track in musicobj.queue"
              v-bind:key="track.uri">
                <th>{{ track.title }}</th>
              </tr>
            </tbody>
          </table>
        </div>  
      </div>
</template>

<script>
export default {
  name: 'Music',
  data: function() {
    return {
      queueString: ''
    }
  },
  props: {
    musicobj: Object
  },
  methods: {
    millisToMinutesAndSeconds(millis) {
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);
      return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    },
    skip() {

      this.axios.get(this.$store.state.adress + '/music?token=' + this.$store.state.token + '&action=skip')
    },
    play() {

      this.axios.get(this.$store.state.adress + '/music?token=' + this.$store.state.token + '&action=play')
    },
    pause() {

      this.axios.get(this.$store.state.adress + '/music?token=' + this.$store.state.token + '&action=pause')
    },
    stop() {

      this.axios.get(this.$store.state.adress + '/music?token=' + this.$store.state.token + '&action=stop')
    },
    addToQueue() {

      this.axios.get(this.$store.state.adress + '/music?token=' + this.$store.state.token + '&action=queue&q=' + encodeURIComponent(this.queueString))
    }
  }
}
</script>

<style>
@import "~bulma/css/bulma.css";
</style>